// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import MintUI from 'mint-ui'
import 'mint-ui/lib/style.css'
import './assets/css/my-mint.css';//全局修改mint-UI样式
import App from './App'
import router from './router'
import VueResource from 'vue-resource'
import store from './store'
import Vant from 'vant';
import 'vant/lib/index.css';
import Cookies from 'js-cookie';
import md5 from 'js-md5';
import cookie from './libs/util.cookies'
import {getParam} from './assets/js/common'
import { Dialog,Toast } from 'vant';

Vue.use(MintUI)
Vue.use(Vant);
Vue.use(VueResource);
Vue.prototype.$md5 = md5;
Vue.http.options.emulateJSON = true;
Vue.prototype.$cookie = cookie;
Vue.http.options.headers = {
  'Content-Type': 'application/json'
};
Vue.http.interceptors.push((request, next) => {   //请求前后对loading的处理
  // request.method = 'POST';
  // 通过控制 组件的`v-show`值显示loading组件
  // store.state.appShowLoading = true
  //token拿的是跟后端登录用户获取的token一样，所以可以先登录后台拿到token之后来微信公众号开发环境使用
  if(request.url.indexOf('/WasteUser/GetUserByToken')!=-1){

    let token=getParam('token');
    if(!token){
      return false;
    }else {
      Vue.http.headers.common.Authorization = token;
    }
  }else if(request.url.indexOf('/WasteUser/GetUserLogin')!=-1 || request.url.indexOf('/WasteLab/GetAllTenant')!=-1){
    // 登录绑定openid

  }else{
    let token=Cookies.get('token');
    if(!token){
      Dialog.alert({
        title: '验证信息过期',
        message: '请关闭页面后重新进入',
      }).then(() => {
        // on close
      });
      // window.location.href='/'
      return false;
    }else {
      Vue.http.headers.common.Authorization = token;
    }
  }
  // if(request.url.indexOf('/User/GetWxUserLogin')==-1 && request.url.indexOf('/User/GetUserLoginByOpenId')==-1 && request.url.indexOf('/device/index')==-1){
  //   let token=Cookies.get('token');
  //   if(!token){
  //     Dialog.alert({
  //       title: '验证信息过期',
  //       message: '请关闭页面后重新进入',
  //     }).then(() => {
  //       // on close
  //     });
  //     // window.location.href='/'
  //     return false;
  //   }else {
  //     Vue.http.headers.common.Authorization = token;
  //   }
  // }
  next((response) => {
    //请求success但returnCode为0的全局设置弹窗信息
    if(response.ok){
      // alert(3)
      if(!response.url.includes('GetUserByToken') && !response.url.includes('GetUserLogin')){
        if(response.body.returnCode==0 || response.body.returnCode==-1){
          Dialog.alert({
            title: '提示',
            message: response.body.message,
          }).then(() => {
            // on close
          });
          Toast.clear();
          // Vue.$toast({
          //   message: response.body.message,
          //   duration: 3000
          // });

        }
      }
    }
    //请求error的全局设置弹窗信息
    // alert(response.ok)
    if(!response.ok){
      // Vue.$toast({
      //   message: '网络错误，请刷新再试',
      //   duration: 1200
      // });
      if(response.status==401){
        Dialog.alert({
          title: '401：验证信息过期',
          message: '请关闭页面后重新进入',
        }).then(() => {
          // on close
        });
      }else{
        Dialog.alert({
          title: '接口异常',
          message: response.status,
        }).then(() => {
          // on close
        });
      }
    }
    store.state.appShowLoading=false;
    return response
  });
});

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {
    App
  }
})



// WEBPACK FOOTER //
// ./src/main.js